import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["render", "onChange"];
import { useValueObserver } from '@superdispatch/hooks';
import { useLayoutEffect, useState } from 'react';
import { renderChildren } from "./renderChildren.js";
export function useVisibilityObserver(node) {
  var {
    threshold = 0,
    marginTop = '0px',
    marginLeft = '0px',
    marginRight = '0px',
    marginBottom = '0px'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var [state, setState] = useState('undetermined');
  var rootMargin = "".concat(marginTop, " ").concat(marginRight, " ").concat(marginBottom, " ").concat(marginLeft);
  useLayoutEffect(() => {
    if (!node || !('IntersectionObserver' in window)) {
      setState('undetermined');
      return;
    }
    var observer = new IntersectionObserver(_ref => {
      var [entry] = _ref;
      setState(entry !== null && entry !== void 0 && entry.isIntersecting && document.visibilityState === 'visible' ? 'visible' : 'invisible');
    }, {
      rootMargin,
      threshold
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [node, threshold, rootMargin]);
  return state;
}
export function VisibilityObserver(_ref2) {
  var {
      render,
      onChange
    } = _ref2,
    options = _objectWithoutProperties(_ref2, _excluded);
  var [node, setNode] = useState(null);
  var visibility = useVisibilityObserver(node, options);
  var children = render({
    ref: setNode,
    visibility
  });
  useValueObserver(visibility, () => {
    onChange === null || onChange === void 0 ? void 0 : onChange(visibility);
  });
  return renderChildren(children);
}